import {
	fontSize12,
	fontSize16,
	gridGutter,
	gridGutterHalf,
	gridGutter1q3,
	gridGutter1q1dot5
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from "../../../../js/shared/new-theme";

export const averageMilesStyle = `
  .info { 
    display: flex;

    &-text {
      margin: 0 0 ${gridGutter1q3}px 0;
      font-size: ${fontSize12};
      font-weight: normal;

      span {
        font-weight: bold;
        color: ${theme.palette.gray[800].value};
        padding-right: ${gridGutter1q3}px;
      }
    }

    &-loading {
      display: inline-block;
    }
  }

  .average-separator {
    margin: ${gridGutter1q1dot5}px 0 ${gridGutter}px 0;
  }
`;

export const offerMilesStyle = `
	a {
		color: ${theme.palette.gray[800].value};
		cursor: pointer;
    text-decoration: underline;
	}

  .title {
    color: ${theme.palette.gray[800].value};
    font-size: ${fontSize16};
    font-weight: bold;
    margin-bottom: ${gridGutter}px;
  }

  .quant-offer-miles {
    margin-bottom: ${gridGutter}px;
    &--wrapper {
      margin: 0 0 ${gridGutterHalf}px 0;
      display: block;
    }
  }

  .payment-deadline-miles {
    margin-bottom: ${gridGutter}px;
    &--wrapper {
      margin: 0 0 ${gridGutterHalf}px 0;
      display: block;
    }
  }

  .average-offer-miles {
    &--wrapper {
      margin: 0 0 ${gridGutterHalf}px 0;
      display: block;
    }
  }

  .price-offer-miles {
    margin-bottom: ${gridGutter}px;
    &--wrapper {
      margin: 0 0 ${gridGutter1q3}px 0;
      display: block;
    }
    &--text {
      font-size: ${fontSize12};
      font-weight: normal;
      span {
        font-weight: bold;
        color: ${theme.palette.gray[800].value};
      }
      padding-bottom: ${gridGutter}px;
    }
    &--loading {
      display: inline-block;
    }
  }

  .miles-reduction-tickets {
    margin: ${gridGutter}px 0;
  }  

  .show-advanced-settings {
    &--label {
      font-size: ${fontSize12};
      font-weight: normal;
    }
  }

  .check-smiles-diamond {
    &--wrapper {
      margin: ${gridGutter}px 0;
    }
    &--separator {
      margin-top: -12px;
    }
    &--label {
      font-size: ${fontSize12};
      font-weight: normal;
      strong {
        font-weight: bold;
        color: ${theme.palette.gray[800].value};
      }
    }
  }

  .alert-offer-miles {
    margin-bottom: ${gridGutter}px;
  }
`;
